import { render } from "./header-user.vue?vue&type=template&id=89b4d0ae&ts=true"
import script from "./header-user.vue?vue&type=script&lang=ts"
export * from "./header-user.vue?vue&type=script&lang=ts"

import "./header-user.vue?vue&type=style&index=0&id=89b4d0ae&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__